import { ArrowUpRight, BookOpen } from "lucide-react";
import { Reveal, Label } from "./motion";
import { ARTICLES } from "../data";

export const Blog = () => (
  <section id="blog" className="px-4 md:px-8 lg:px-12 py-24 md:py-32 lg:py-48 bg-[#0A0A0A]" data-testid="blog-section">
    <div className="mb-16">
      <Reveal><Label>05 — Field Notes</Label></Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-5xl sm:text-6xl lg:text-8xl leading-none mt-6 text-white">
          Training science
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="text-zinc-400 text-base lg:text-lg mt-6 max-w-xl leading-relaxed">
          Evidence-based principles behind the way I coach — every claim backed by peer-reviewed research and trusted sources.
        </p>
      </Reveal>
    </div>

    <div className="space-y-6">
      {ARTICLES.map((article, idx) => (
        <Reveal key={idx} delay={0.05 * idx}>
          <article className="border border-zinc-800 bg-[#121212] p-8 lg:p-14" data-testid={`article-${idx}`}>
            <div className="grid lg:grid-cols-12 gap-10">
              <div className="lg:col-span-7">
                <div className="flex items-center gap-3 mb-6">
                  <BookOpen size={16} className="text-[#FF3B30]" />
                  <span className="text-xs uppercase tracking-[0.25em] text-zinc-500 font-medium">{article.tag}</span>
                </div>
                <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[0.95] text-white">
                  {article.title}
                </h3>
                <p className="text-zinc-400 text-base lg:text-lg mt-8 leading-relaxed">
                  {article.summary}
                </p>
              </div>

              <div className="lg:col-span-5 lg:border-l lg:border-zinc-800 lg:pl-10">
                <span className="text-xs uppercase tracking-[0.25em] text-zinc-500 font-medium">Sources & Citations</span>
                <ul className="mt-6 space-y-6">
                  {article.sources.map((s, i) => (
                    <li key={i}>
                      <a
                        href={s.url}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={`article-${idx}-source-${i}`}
                        className="group flex gap-3 text-sm text-zinc-400 hover:text-white transition-colors"
                      >
                        <span className="font-display text-[#FF3B30] text-lg leading-none shrink-0">{`0${i + 1}`}</span>
                        <span className="leading-relaxed">
                          {s.label}
                          <ArrowUpRight size={14} className="inline ml-1 text-zinc-600 group-hover:text-[#FF3B30] transition-colors" />
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </article>
        </Reveal>
      ))}
    </div>

    <p className="text-[11px] text-zinc-600 mt-10 leading-relaxed max-w-2xl">
      Summarized for educational purposes and not a substitute for medical advice. Always train within your own ability and consult a professional where appropriate.
    </p>
  </section>
);
